export default __webpack_public_path__ + "static/media/scalesology-main-horizontal.65eb7f62.svg";